import { render, staticRenderFns } from "./ContractSettings.vue?vue&type=template&id=47651db5&scoped=true"
import script from "./ContractSettings.vue?vue&type=script&lang=js"
export * from "./ContractSettings.vue?vue&type=script&lang=js"
import style0 from "./ContractSettings.vue?vue&type=style&index=0&id=47651db5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47651db5",
  null
  
)

export default component.exports